"use client";

import type { FC, Ref } from "react";
import { Grid } from "@huub-web/ui/components/Grid";

import { TemplatesParser } from "../../components";
import type { TemplateCollection } from "../../types";

export interface GridTemplateProps {
  /**
   * The templates to render within the grid
   */
  templates: TemplateCollection;
  /**
   * The variant of the grid
   */
  variant?: "verticalCard" | "card";
  /**
   * The title of the grid
   */
  title?: string;
  /**
   * The description of the grid
   */
  description?: string;
}

/**
 * A template that renders child templates in a responsive grid layout
 */
export const GridTemplate: FC<
  GridTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ variant = "verticalCard", title, description, templates, ref }) => (
  <Grid
    ref={ref}
    title={title}
    description={description}
    variant={variant}
    // applyMotion
  >
    <TemplatesParser templates={templates} level={1} />
  </Grid>
);
